import { m } from '../hyperscript';
var ListenerCache = /** @class */ (function () {
    function ListenerCache(object) {
        this.object = object;
        this.attached = new Map();
    }
    ListenerCache.prototype.attach = function (events) {
        var _this = this;
        events.forEach(function (key) {
            if (_this.attached.has(key))
                return;
            _this.attached.set(key, _this.object.add(key, function (event) {
                if (event === void 0) { event = { redraw: true }; }
                event.redraw = true;
                _this.object.hit(key, event);
                if (event.redraw)
                    m.redraw();
            }));
        });
        this.remove(Array.from(this.attached.keys()).filter(function (key) { return events.indexOf(key) === -1; }));
    };
    ListenerCache.prototype.remove = function (selected) {
        var _this = this;
        Array.from(this.attached.keys())
            .filter(function (key) { return !selected || selected.indexOf(key) > -1; })
            .forEach(function (event) {
            _this.attached.get(event)();
            _this.attached.delete(event);
        });
    };
    return ListenerCache;
}());
export { ListenerCache };
